/**
 * KAN-976: таблица журнала кошелька: дата, тип, описание, аккаунт, сумма, остаток после.
 */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { formatEntryDate, formatRub, formatSignedRub, isPositiveAmount } from '@/lib/wallet';
import type { WalletEntry } from '@/types/wallet';

interface WalletEntriesTableProps {
  entries: WalletEntry[];
}

export function WalletEntriesTable({ entries }: WalletEntriesTableProps) {
  return (
    <div className="overflow-x-auto">
      <Table data-testid="wallet-entries-table">
        <TableHeader>
          <TableRow>
            <TableHead>Дата</TableHead>
            <TableHead>Тип</TableHead>
            <TableHead>Описание</TableHead>
            <TableHead>Аккаунт</TableHead>
            <TableHead className="text-right">Сумма</TableHead>
            <TableHead className="text-right">Остаток после</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {entries.map((entry) => (
            <TableRow key={entry.id} data-testid="wallet-entry-row">
              <TableCell className="whitespace-nowrap">{formatEntryDate(entry.created_at)}</TableCell>
              <TableCell className="whitespace-nowrap">{entry.kind_label}</TableCell>
              <TableCell>{entry.description || '-'}</TableCell>
              <TableCell className="whitespace-nowrap">{entry.telegram_account_id || '-'}</TableCell>
              <TableCell
                data-testid="wallet-entry-amount"
                className={cn(
                  'whitespace-nowrap text-right font-medium',
                  isPositiveAmount(entry.amount) ? 'text-green-600' : 'text-red-600'
                )}
              >
                {formatSignedRub(entry.amount)}
              </TableCell>
              <TableCell className="whitespace-nowrap text-right">
                {formatRub(entry.balance_after)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
